import SearchField from '@/fields/SearchField';
class ElementField extends SearchField {
    constructor(label, m, s, elementKey) {
        const config = {
            suggestions: ElementField._generateOptions(m, s, elementKey),
            hintsLimit: -1,
            isAdaptiveField: true,
            qtyDisplayHints: 10,
            isStrictMode: true,
            isSortHints: false,
            showHintsAfterSelect: true,
            inputFieldProps: { placeholder: 'Пожалуйста выберите элемент' },
            searchDelay: 250,
            isWithMatchMark: true,
            isSimpleSearch: false,
        };
        super(label, config);
    }
    updateElement(m, s, elementKey) {
        const options = ElementField._generateOptions(m, s, elementKey);
        this.changeOptions(options);
    }
    static _generateOptions(m, s, elementKey) {
        var _a, _b;
        const list = ((_b = (_a = window === null || window === void 0 ? void 0 : window.calcZV_ductsAdditionals) === null || _a === void 0 ? void 0 : _a[m]) === null || _b === void 0 ? void 0 : _b[s]) || [];
        return Object.keys(list).map((x, i) => {
            var _a, _b, _c;
            const text = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window[elementKey]) === null || _a === void 0 ? void 0 : _a[s]) === null || _b === void 0 ? void 0 : _b[x]) === null || _c === void 0 ? void 0 : _c.text;
            return { value: x, label: text || `Без имени - ${i}` };
        });
    }
}
export default ElementField;
